import Reserving from './Reserving';
import CustomAssessment from './CustomAssessment';
import DayOneAssessmentSimple from './components/DayOneSimple';
import DayOneAssessmentFatalForm from './day-one/fatal/Form';
import DayOneAssessmentFatalResults from './day-one/fatal/Results';
import DayOneAssessmentLostForm from './day-one/lost/Form';
import DayOneAssessmentLostResults from './day-one/lost/Results';

export default [
    {
        name: 'reserving',
        path: '/reserving',
        component: Reserving,
        children: [
            {
                name: 'reserving::day-one-assessment',
                path: 'day-one-assessment',
                component: DayOneAssessmentSimple,
                children: [
                    {
                        name: 'reserving::day-one-assessment::fatal',
                        path: 'fatal',
                        components: {
                            form: DayOneAssessmentFatalForm,
                            results: DayOneAssessmentFatalResults
                        }
                    },
                    {
                        name: 'reserving::day-one-assessment::lost',
                        path: 'lost',
                        components: {
                            form: DayOneAssessmentLostForm,
                            results: DayOneAssessmentLostResults
                        }
                    }
                ]
            },
            {
                name: 'reserving::custom-assessment',
                path: 'custom-assessment',
                component: CustomAssessment,
            }
        ]
    },
];



// WEBPACK FOOTER //
// ./src/pages/reserving/routes.js